import { booleanAttribute, Component, Input, HostBinding } from '@angular/core';

//Composant fonte icone
@Component(
	{
		selector: 'val-fonte-icone',
		imports:
			[
			],
		templateUrl: './fonte-icone.component.html',
		styleUrl: './fonte-icone.component.scss'
	})
export class FonteIconeComponent {
	//Création
	constructor() {
		this.utiliserRotation = false;
		this.utiliserRotation180 = false;
		this.utiliserRotation270 = false;
		this.rotation = false;
	}

	//Classe css de l’icone
	@Input()
	public iconeCss!: string;

	//Indique si la rotation est utilisée
	@Input({ transform: booleanAttribute })
	public utiliserRotation: boolean;

	//Indique si la rotation est utilisée
	@Input({ transform: booleanAttribute })
	public utiliserRotation180: boolean;

	//Indique si la rotation est utilisée
	@Input({ transform: booleanAttribute })
	public utiliserRotation270: boolean;

	//Indique si en rotation
	@Input({ transform: booleanAttribute })
	public rotation: boolean;

	@Input()
	public couleurIcone?: string;

	@HostBinding('style')
	get styleHote(): Partial<CSSStyleDeclaration> {
		return {
			'--icone-couleur': this.couleurIcone
		} as Partial<CSSStyleDeclaration>;
	}
}
